import { render, staticRenderFns } from "./Category.vue?vue&type=template&id=552be79d&"
import script from "./Category.ts?vue&type=script&lang=ts&"
export * from "./Category.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports